import Image from 'next/image';
import styles from './blogCard.module.scss';
import { BlogPostType } from 'types';
import { TbEdit } from 'react-icons/tb';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import { AppLinkComp } from 'components';
import { PATH } from 'data';
function BlogCardComp({
  item
}: {
  item: BlogPostType;
}) {
  const {
    langText
  } = useContext(GlobalContext);
  const lang = langText.blog;
  return <AppLinkComp href={PATH(langText.lang).blog.detail(item.slug)} className={`${styles['post-card']} flex-1 p-2`} data-sentry-element="AppLinkComp" data-sentry-component="BlogCardComp" data-sentry-source-file="blogCard.index.tsx">
            <Image className="mb-2 w-100" src={item.image.file} width={328} height={200} alt={item.image.alt ?? ''} data-sentry-element="Image" data-sentry-source-file="blogCard.index.tsx" />
            <div className="gap-8 flex-wrap mb-1">
                {item.categories?.map((item, index) => <p key={index} className="t-primary">
                        {item.title}
                    </p>)}
            </div>
            <h3 className="mb-1 t-h4">{item.title}</h3>
            <p className="mb-2">{item.description}</p>
            <div className={`align-items-center gap-8 ${item.author ? '' : 'd-none'}`}>
                <TbEdit className="t-dark4" data-sentry-element="TbEdit" data-sentry-source-file="blogCard.index.tsx" />
                <p>
                    <span className="t-dark4">{lang.author}:</span> {item.author?.first_name ?? ''}
                </p>
            </div>
        </AppLinkComp>;
}
export default BlogCardComp;